import { Component } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subject, takeUntil } from 'rxjs';
import { EXPEDITION_USER } from 'src/app/constants/endpoint.const';
import { IExpeditionStatus } from 'src/app/models/profile.model';
import { BypassApiService } from 'src/app/services/api/bypass.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-expedition',
  standalone: false,
  templateUrl: './expedition.component.html',
  styleUrl: './expedition.component.scss'
})
export class ExpeditionComponent {
  destroy$ = new Subject()
  loading: boolean = true;
  collectedExpedition: object = {};
  listOfData: IExpeditionStatus[] = [];

  constructor(
    private message: NzMessageService,
    private byPassService: BypassApiService
  ) { }
  
  ngOnInit(): void {
    this.getListExpedition();
    setTimeout(() => {
      this.loading = false
    }, 1000)
  }

  getClassStatus(status: boolean): string {
    return status === true ? 'activated' : 'deactivated';
  }

  getListExpedition(): void {
    this.byPassService
      .request<any>({
        method: 'GET',
        endpoint: environment.SWITCH_URL + EXPEDITION_USER
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.listOfData = response.data.map((item: any) => ({
            shipping_logo: item.logo,
            shipping_name: item.shipping_name,
            is_active: item.is_active,
            id: item.id
          }));
        },
        error: (error) => {
          this.message.error('Failed to load expedition data.');
        }
      });
  }

  changeStatus(item: IExpeditionStatus): void {
    this.byPassService
      .request<any>({
        method: 'PUT',
        endpoint: environment.SWITCH_URL + EXPEDITION_USER,
        body: {
          shipment_id: item.id,
          is_active: item.is_active
        },
      })
          .pipe(takeUntil(this.destroy$))
          .subscribe(
        {
            next: (res) => {
              const statusMessage = item.is_active ? 'activated' : 'deactivated';
              this.message.success(`${item.shipping_name} has been successfully ${statusMessage}.`);
            },
            error: (error) => {
              item.is_active = !item.is_active;
              this.message.error('Failed to update expedition status.');
            }
          }
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
